import { Component } from '@angular/core';
import { Events, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { PosmSubitemDescriptionPage } from '../posm-subitem-description/posm-subitem-description';
import { OrderPage } from '../order/order';

import { AuthProvider } from '../../providers/auth/auth';
import { OrderProvider } from "../../providers/order/order";
import { PosmSubitemProvider } from "../../providers/posm-subitem/posm-subitem";
import { PosmSubitem } from "../../models/posm-subitem.model";

import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { listAnimation } from '../../animations/list-animation';

import { BasketPage } from "../basket/basket";
import { OrdersListPage } from "../orders-list/orders-list";

import { Storage } from '@ionic/storage';

@IonicPage()
@Component({
  selector: 'page-posm-subitems',
  templateUrl: 'posm-subitems.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class PosmSubitemsPage extends BasketPage {
  public posmSubitemDescription: PosmSubitemDescriptionPage;
  public orderList: OrdersListPage;
  public loading: boolean;

  parentID: number;
  parentType: string;
  parentName: string;
  parentTitle: string;
  parentContent: string;
  parentImage: string;

  posmSubitems: Array<PosmSubitem>;
  showPosmSubitems: Array<PosmSubitem>;
  products;
  productFilterId: number = 0;

  constructor(public storage: Storage, public events: Events, public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public posmSubitemProvider: PosmSubitemProvider, public modalCtrl: ModalController, public viewCtrl: ViewController, public translate: TranslateService, public authProvider: AuthProvider) {
    super(storage, events, orderProvider, navCtrl, navParams, viewCtrl, translate, modalCtrl, authProvider);
    this.orderList = new OrdersListPage(storage, events, orderProvider, navCtrl, navParams, viewCtrl, translate, modalCtrl);
    this.posmSubitemDescription = new PosmSubitemDescriptionPage(storage, navCtrl, navParams, translate, modalCtrl);

    this.parentType = navParams.get("parentType");

    if (this.parentType === "POSM_ITEM" ) {
      this.parentID = navParams.get('parentID');
      this.parentName = navParams.get('parentName');
      this.parentTitle = navParams.get('parentTitle');
      this.parentContent = navParams.get('parentContent');
      this.parentImage = navParams.get('parentImage');
    } else if (this.parentType === "POSM_CATEGORY") {
      this.parentID = navParams.get('parentID');
      this.parentName = navParams.get('parentName');
      this.parentTitle = navParams.get('parentTitle');
      this.parentContent = navParams.get('parentContent');
    }
  }

  getPosmSubitems() {
    this.loading = true;
    this.posmSubitemProvider.getByParentID(this.parentID, this.parentType)
      .subscribe(
        posmSubitems => {
          this.posmSubitems = posmSubitems;
          this.reloadBasketContent().then(() => {
            this.getPosmSubitemValues();
          });
        },
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.events.publish('orderList:get_data');
          this.loading = false;
        }
      );
  }

  filterByProduct(product_id: number) {
    if (product_id == -1) {
      this.productFilterId = 0;
    } else {
      this.productFilterId = product_id;
    }
    this.getPosmSubitemValues();
  }

  reloadPosmSubitems(refresher) {
    this.getPosmSubitems();
    refresher.complete();
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.inBasket.subscribe((inBasket) => {
      if(!inBasket) {
        this.getPosmSubitems();
      }
    });
  }

  getPosmSubitemValues () {
    this.showPosmSubitems = new Array();
    this.products = new Array();
    for (const key of Object.keys(this.posmSubitems)) {
      if (this.posmSubitems[key].product_id && this.products.map((product) => product.id).indexOf(parseInt(this.posmSubitems[key].product_id)) === -1) {
        this.products.push({
          id: parseInt(this.posmSubitems[key].product_id),
          name: this.posmSubitems[key].product_name,
        });
      }

      if ((this.productFilterId !== 0
        && parseInt(this.posmSubitems[key].product_id) === this.productFilterId)
        || this.productFilterId === 0) {
        this.showPosmSubitems[key] = this.posmSubitems[key];
        for (const basketKey of Object.keys(this.basket)) {
          if (this.basket[basketKey].id === this.posmSubitems[key].id) {
            this.showPosmSubitems[key] = this.basket[basketKey];
            break;
          }
        }
      }
    }
  }

  increaseElement (posmSubitem: PosmSubitem) {
    this.increaseBasketElementInBasket(posmSubitem);
    this.getPosmSubitemValues();
  }

  decreaseElement (posmSubitem: PosmSubitem) {
    this.decreaseBasketElementInBasket(posmSubitem);
    this.getPosmSubitemValues();
  }

  openSendEmailForm(posmSubitemID: string, posterUrl: string) {

    this.storage.get('current_brand').then((brand) => {
      let tosModal = this.modalCtrl.create(OrderPage, {
        orderType: "print",
        posmSubitemId: posmSubitemID,
        posterUrl: posterUrl
      }, { cssClass: brand.name });
      tosModal.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/posm-subitems/posm-subitems.ts